(function () {
    'use strict';

    angular
        .module('app')
        .factory('WorkflowService', WorkflowService);

    WorkflowService.$inject = [
        '$http',
        'DataService',
        'UrlService'];

    function WorkflowService(
        $http,
        DataService,
        UrlService) {
        var resourceUrl = 'workflowdefinition';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            multiCopy: multiCopy,
            multiDelete: multiDelete,
            getCopy: getCopy,
            count: count
        });

        return service;

        /**
         * Create copies of the specified workflows.
         *
         * @param {array} workflowIds - An array of workflow ids for the workflows to be copied.
         * @return {promise} A promise resolved once the workflow copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(workflowIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/workflowcopy', workflowIds);
        }

        /**
         * Deletes the specified workflows
         *
         * @param {array} workflowIds - An array of workflow ids for the workflows to be deleted.
         * @return {promise} A promise resolved once the workflow deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(workflowIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/workflowdelete', workflowIds);
        }

        /**
         * GET a copy of workflow with the specified id
         */
        function getCopy(workflowId) {
            return $http.get(UrlService.getWebAPIUrl() + '/workflowdefinition/' + workflowId + '/copy')
                .then(function (response) {
                    if (!_.isNil(response) && !_.isNil(response.data)) {
                        delete response.data.UpdatedDate;
                        delete response.data.CreatedDate;
                        delete response.data.Name;
                    }
                    return response.data;
                });
        }

        /**
         * Gets the count of workflow definitions
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/workflowdefinition/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();